<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    class-name="user-field"
    >
    <template slot-scope="scope">
      <el-popover
        trigger="hover"
        >
        <el-table :data="getData(scope.row)"
          :show-header="false"
          row-class-name="popover-field"
          >
          <el-table-column
            prop="icon"
            width="35"
            align="center"
            >
            <template slot-scope="scope">
              <div v-if="scope.row['icon'] === 'uid'">
                ID
              </div>
              <div v-else-if="scope.row['icon'] === 'display_name'">
                <i class="el-icon-user"></i>
              </div>
              <div v-else-if="scope.row['icon'] === 'email'">
                <i class="el-icon-message"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            prop="data">
          </el-table-column>
        </el-table>
        <el-tag
          slot="reference"
          :disable-transitions="true"
          @click="$router.push({ path: '/user/admin/edit/' + scope.row.uid })"
          >
          {{ scope.row.email }}
        </el-tag>
      </el-popover>
    </template>
  </el-table-column>
</template>

<script>

export default {
  name: 'user-field',
  props: {
  },
  data () {
    return {
      label: this.$t('api.user.name')
    }
  },
  created () {
  },
  methods: {
    getData (data) {
      var retData = [{
        icon: 'uid',
        data: data['uid']
      }, {
        icon: 'display_name',
        data: data['display_name']
      }, {
        icon: 'email',
        data: data['email']
      }]
      return retData
    }
  }
}
</script>
